import { render, staticRenderFns } from "./view-room.vue?vue&type=template&id=e5377148&"
import script from "./view-room.vue?vue&type=script&lang=ts&"
export * from "./view-room.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports